var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edi_setting"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.contract_url,"seamless":"","referrerpolicy":"no-referrer-when-downgrade"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }